<template>
  <div class="recursos container text m-y-2-sm m-y-3-md">
    <h2 class="titulo">Recursos</h2>
    <div class="subseccion m-y-1 m-b-1-sm m-b-0-md">
      <div class="titulo-subseccion">
        <h3 class="subtitulo no-margin">Herramientas Interinstitucionales</h3>
        <hr v-if="!tieneVistaSimplificada" />
      </div>
      <div class="grid-descargas m-t-1 ocultar-vista-simplificada">
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          link="https://app.semarnat.gob.mx/sargazodesa"
          descripcion="Sistema de Monitoreo de Sargazo Recolectado"
          nombre="SEMARNAT: SIMSAR"
          imagen_lap="portadas_version_escritorio/sargazo-logohome.jpg"
          imagen_cel="portadas_version_movil/Simasar.jpg"
        />
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          link="https://simar.conabio.gob.mx/"
          descripcion="Sistema de Información y Análisis Marino Costero"
          nombre="CONABIO: SIMAR"
          imagen_lap="portadas_version_escritorio/Simar.jpg"
          imagen_cel="portadas_version_movil/Simar.jpg"
        />
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          link="https://qroo.gob.mx/sema/comunicado-de-presencia-de-sargazo-en-playas-en-el-estado-de-quintana-roo/"
          descripcion="Semáforo de sargazo"
          nombre="SEMAR"
          imagen_lap="portadas_version_escritorio/Semar.jpg"
          imagen_cel="portadas_version_movil/Semar.jpg"
        />
      </div>
      <div class="a11y-simplificada-block">
        <div class="lista-elementos-simplificados">
          <a href="https://app.semarnat.gob.mx/sargazodesa" target="_blank" rel="noopener">Sistema de Monitoreo de Sargazo Recolectado</a>
          <a href="https://simar.conabio.gob.mx/" target="_blank" rel="noopener">Sistema de Información y Análisis Marino Costero</a>
          <a href="https://qroo.gob.mx/sema/comunicado-de-presencia-de-sargazo-en-playas-en-el-estado-de-quintana-roo/" target="_blank" rel="noopener">Semáforo de sargazo</a>
        </div>
      </div>
    </div>
    
    <div class="subseccion m-y-1 m-b-1-sm m-b-0-md">
      <div class="titulo-subseccion">
        <h3 class="subtitulo no-margin">Presentaciones</h3>
        <hr v-if="!tieneVistaSimplificada" />
        <p>Seminario-Taller Nacional sobre teledetección, monitoreo, pronóstico y alerta temprana del sargazo pelágico que arriba a las costas mexicanas: Descubriendo sinergias y construyendo puentes hacia un sistema integral y regional</p>
      </div>
      <div class="grid-descargas m-t-1 ocultar-vista-simplificada">
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          :link="`${cdnArchivosSargazo}/acciones/3_Comunicacion-y-Educacion_Presentacion-5-Monitoreo-del-sargazo-en-el-LANoT.pdf`"
          descripcion="Monitoreo del sargazo en el LANOT"
          nombre="Presentación Sargazo"
          imagen_lap="portadas_version_escritorio/presentacion-1.png"
          imagen_cel="portadas_version_movil/presentacion-1.png"
        />
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          :link="`${cdnArchivosSargazo}/acciones/3_Comunicacion-y-Educacion_Presentacion-6-Sistema-de-monitoreo-en-tiempo-real-de-corrientes-marinas-y-presencia-de-sargazo-en-el-caribe-mexicano.pdf`"
          descripcion="Sistema de monitoreo en tiempo-real de corrientes marinas y presencia de sargazo en el caribe mexicano"
          nombre="Presentación Sargazo"
          imagen_lap="portadas_version_escritorio/presentacion-2.png"
          imagen_cel="portadas_version_movil/presentacion-2.png"
        />
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          :link="`${cdnArchivosSargazo}/acciones/3_Comunicacion-y-Educacion_Presentacion-7-Deteccion-de-sargazo-con-imagenes-de-alta-resolucion-espacial-para-la-estimacion-de-patrones-locales.pdf`"
          descripcion="Detección de sargazo con imágenes de alta resolución espacial para la estimación de patrones locales"
          nombre="Presentación Sargazo"
          imagen_lap="portadas_version_escritorio/presentacion-3.png"
          imagen_cel="portadas_version_movil/presentacion-3.png"
        />
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          :link="`${cdnArchivosSargazo}/acciones/3_Comunicacion-y-Educacion_Presentacion-8-Dinamica-de-transporte-de-sargazo-pelagico-en-las-cercanias-del-Caribe-Mexicano-analisis-de-sensibilidad.pdf`"
          descripcion="Dinámica de transporte de sargazo pelágico en las cercanías del Caribe Mexicano análisis de sensibilidad"
          nombre="Presentación Sargazo"
          imagen_lap="portadas_version_escritorio/presentacion-4.png"
          imagen_cel="portadas_version_movil/presentacion-4.png"
        />
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          :link="`${cdnArchivosSargazo}/acciones/3_Comunicacion-y-Educacion_Reporte-Seminario-Taller.pdf`"
          descripcion="Seminario-Taller Nacional sobre teledetección, monitoreo, pronóstico y alerta temprana del sargazo pelágico que arriba a las costas mexicanas"
          nombre="Reporte Seminario - Taller"
          imagen_lap="portadas_version_escritorio/presentacion-5.png"
          imagen_cel="portadas_version_movil/presentacion-5.png"
        />
      </div>
      <div class="a11y-simplificada-block">
        <div class="lista-elementos-simplificados">
          <a :href="`${cdnArchivosSargazo}/acciones/3_Comunicacion-y-Educacion_Presentacion-5-Monitoreo-del-sargazo-en-el-LANoT.pdf`" target="_blank" rel="noopener">Monitoreo del sargazo en el LANOT</a>
          <a :href="`${cdnArchivosSargazo}/acciones/3_Comunicacion-y-Educacion_Presentacion-6-Sistema-de-monitoreo-en-tiempo-real-de-corrientes-marinas-y-presencia-de-sargazo-en-el-caribe-mexicano.pdf`" target="_blank" rel="noopener">Sistema de monitoreo en tiempo-real de corrientes marinas y presencia de sargazo en el caribe mexicano</a>
          <a :href="`${cdnArchivosSargazo}/acciones/3_Comunicacion-y-Educacion_Presentacion-7-Deteccion-de-sargazo-con-imagenes-de-alta-resolucion-espacial-para-la-estimacion-de-patrones-locales.pdf`" target="_blank" rel="noopener">Detección de sargazo con imágenes de alta resolución espacial para la estimación de patrones locales</a>
          <a :href="`${cdnArchivosSargazo}/acciones/3_Comunicacion-y-Educacion_Presentacion-8-Dinamica-de-transporte-de-sargazo-pelagico-en-las-cercanias-del-Caribe-Mexicano-analisis-de-sensibilidad.pdf`" target="_blank" rel="noopener">Dinámica de transporte de sargazo pelágico en las cercanías del Caribe Mexicano análisis de sensibilidad</a>
          <a :href="`${cdnArchivosSargazo}/acciones/3_Comunicacion-y-Educacion_Reporte-Seminario-Taller.pdf`" target="_blank" rel="noopener">Seminario-Taller Nacional sobre teledetección, monitoreo, pronóstico y alerta temprana del sargazo pelágico que arriba a las costas mexicanas</a>
        </div>
      </div>
    </div>


    <div class="subseccion m-y-1 m-b-1-sm m-b-0-md">
      <div class="titulo-subseccion">
        <h3 class="subtitulo no-margin">Artículos</h3>
        <hr v-if="!tieneVistaSimplificada" />
      </div>
      <div class="grid-descargas m-t-1 ocultar-vista-simplificada">
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          :link="`${cdnArchivosSargazo}/El_Sargazo_en_el_Caribe_Mexicanopdf.pdf`"
          descripcion="El Sargazo en el Caribe Mexicano"
          nombre="Artículo El Sargazo en el Caribe Mexicano"
          imagen_lap="portadas_version_escritorio/articulo-1.jpg"
          imagen_cel="portadas_version_movil/sargazo-1.jpg"
        />
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          link="https://avanceyperspectiva.cinvestav.mx/sargazo-conociendo-al-enemigo/"
          descripcion="Sargazo, Conociendo al Enemigo"
          nombre="Artículo Sargazo, Conociendo al Enemigo"
          imagen_lap="portadas_version_escritorio/articulo-2.jpg"
          imagen_cel="portadas_version_movil/nota-cinvestav.jpg"
        />
      </div>
      <div class="a11y-simplificada-block">
        <div class="lista-elementos-simplificados">
          <a :href="`${cdnArchivosSargazo}/El_Sargazo_en_el_Caribe_Mexicanopdf.pdf`" target="_blank" rel="noopener">El Sargazo en el Caribe Mexicano</a>
          <a href="https://avanceyperspectiva.cinvestav.mx/sargazo-conociendo-al-enemigo/" target="_blank" rel="noopener">Sargazo, Conociendo al Enemigo</a>
        </div>
      </div>
    </div>
    
    <div class="subseccion m-y-1 m-b-1-sm m-b-0-md">
      <div class="titulo-subseccion">
        <h3 class="subtitulo no-margin">Comunicados</h3>
        <hr v-if="!tieneVistaSimplificada" />
      </div>
      <div class="grid-descargas m-t-1 ocultar-vista-simplificada">
        <LinkPDF
          class="m-b-1-sm m-b-0-md"
          link="https://conacyt.mx/sargazo/index.php/materiales-de-consulta/18-materiales/102-participa-el-conacyt-en-conferencia-internacional-sobre-los-sargazos"
          descripcion="Participa en el Conacyt en la Conferencia Internacional sobre los Sargazos"
          nombre="Comunicado de conferencia sobre sargazo"
          imagen_lap="portadas_version_escritorio/comunicado.jpg"
          imagen_cel="portadas_version_movil/comunicado.jpg"
        />
      </div>
      <div class="a11y-simplificada-block">
        <div class="lista-elementos-simplificados">
          <a href="https://conacyt.mx/sargazo/index.php/materiales-de-consulta/18-materiales/102-participa-el-conacyt-en-conferencia-internacional-sobre-los-sargazos" target="_blank" rel="noopener">Participa en el Conacyt en la Conferencia Internacional sobre los Sargazos</a>
        </div>
      </div>
    </div>

    <div class="bibliografia m-y-1 m-b-1-sm m-b-0-md">
      <ReferenciasLineasInvestigacion
        titulo="Bibliografía de Líneas de Investigación"
        :referencias="require('@/assets/data/referencias_biblio.json')"
        :descarga="`${cdnArchivosSargazo}/pdf_lineas_investigacion.pdf`"
      />
    </div>

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md a11y-simplificada-block">
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSdM2lwTbT7jA2Hz31cPtHrMvU3FWz62U7gBeFj99tVSIq-YAA/viewform">
        <b>Encuesta pública</b>
      </a>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LinkPDF from "@/components/recursos/LinkPDF.vue";
import ReferenciasLineasInvestigacion from "@/components/utiles/ReferenciasLineasInvestigacion.vue"

export default {
  name: "Recursos",
  components: {
    LinkPDF,
    ReferenciasLineasInvestigacion
  },
  data() {
    return {
      subsecciones: [],
    };
  },
  computed: {
    ...mapGetters(["cdnArchivosSargazo"]),
    tieneVistaSimplificada(){
      return this.$store.getters.tieneVistaSimplificada;
    }
  }
};
</script>

<style lang="scss" scoped>
.recursos {
  .subseccion {
    .titulo-subseccion {
      .subtitulo {
        font-weight: 400;
        @media (min-width: map-get($media-queries-limit, "mobile")) {
          font-weight: 600;
        }
      }
      .no-margin {
        margin: 16px 0;
      }
      hr {
        border-color: #505050;
        margin: 0;
      }
    }
    .grid-descargas {
      @media (min-width: map-get($media-queries-limit, "mobile")) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 16px;
        row-gap: 32px;
      }
    }
    .lista-elementos-simplificados {
      display: flex;
      flex-direction: column;
      a {
        width: fit-content;
        margin: 16px 0;
      }
    }
  }
}
</style>